import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';


@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.css']
})

export class ConfirmModalComponent implements OnInit {

    @Input() titleTxt: String;
    @Input() subtitleTxt: String;
    @Input() confirmTxt = 'Sim'
    @Input() dismissTxt = 'Não'
    @Input() idModal = 'confirmModal';

    @Output() confirmData: EventEmitter<any> = new EventEmitter();
    @Output() dismissData: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    onConfirm() {
        this.confirmData.emit();
    }

    onDismiss() {
        this.dismissData.emit();
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-modal/confirm-modal.component.ts